import styles from './BookPage.module.css';
import { AudioManager } from '../audio/AudioManager';
import { AudioPlayer } from '../audio/AudioPlayer';
import { BookHeader } from '../components/book/BookHeader';
import { BookChapter } from '../components/book/BookChapter';
import { BookFooter } from '../components/book/BookFooter';
import { AmbientSnowEffect } from '../components/book/AmbientSnowEffect';
import { saveLink } from '../utils/GraphqlUtils';

const BookPage: React.FC = () => {
  // saveLink({
  //   url: '/',
  //   description: 'Book page'
  // });
  return (
    <div className={styles.page}>
      <AudioManager src="/audio/song1.mp3">
        <AudioPlayer/>
        <AmbientSnowEffect /> {/* floating glowing particles */}
        {/* Header */}
        <BookHeader author="Sonyun" title="Adventures in Code & Curiosity" />

        {/* Chapters */}
        <BookChapter title="Chapter 1: The Beginning">
          <p className={`${styles.paragraph} ${styles.dropCap}`}>
            Once upon a time, in a small room filled with screens and coffee cups,
            Sonyun began the journey into the curious world of code. Tinkering with
            languages like Java, JavaScript, and the occasional Python, Sonyun chased
            the thrill of solving the puzzle no one else dared to try.
          </p>
          <p className={styles.paragraph}>
            In free time, Sonyun explores forests and digital landscapes alike,
            seeking inspiration in the quiet rustle of leaves or the glow of a terminal
            at midnight.
          </p>
        </BookChapter>

        <BookChapter title="Chapter 2: Adventures">
          <ul className={styles.list}>
            <li>Crafted a tiny game that surprisingly captivated a friend group of three.</li>
            <li>Built a weather app just to prove that rain could be forecasted with style.</li>
            <li>Once spent an entire weekend optimizing a function that didn’t really need optimization — because it was fun.</li>
          </ul>
        </BookChapter>

        <BookChapter title="Chapter 3: Collections">
          <ul className={styles.list}>
            <li>Favorite Books: <em>The Hobbit</em>, <em>Gödel, Escher, Bach</em>, <em>Neuromancer</em></li>
            <li>Favorite Music: Lo-fi beats, classic rock, synthwave</li>
            <li>Hobbies: Sketching, chess, urban exploration</li>
            <li>Inspirations: Nature, architecture, and the code left behind by old programmers</li>
          </ul>
        </BookChapter>

        <BookChapter title="Chapter 4: Letters">
          <p className={styles.paragraph}>
            <em>“Curiosity is the compass, and mistakes are the map.”</em>
          </p>
          <p className={`${styles.paragraph} ${styles.dropCap}`}>
            To anyone who finds this page: explore, create, and don’t be afraid of the margins. They’re where the magic happens.
          </p>
        </BookChapter>

        <BookChapter title="Chapter 5: Curiosities">
          <ul className={styles.gallery}>
            <li className={styles.galleryItem}>Sketch of a forest path with hidden digital symbols</li>
            <li className={styles.galleryItem}>Screenshot of a retro terminal with a mysterious message</li>
            <li className={styles.galleryItem}>Tiny doodles of robots tinkering with code</li>
          </ul>
        </BookChapter>

        {/* Footer */}
        <BookFooter email = "sonyun@example.com"
          note="Thanks for flipping through my little digital book."
          numberOfPage={12}/>
      </AudioManager>
    </div>
  );
};

export default BookPage;
